import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import FAQ from "./Component/FAQ";
import CookiePolicy from "./Component/CookiePolicy";
import PolicyIndex from "./Component/PolicyIndex";
import DataRights from "./Component/DataRights";
import TermsOfSale from "./Component/TermsOfSale";
import ParcelIssues from "./Component/ParcelIssues";
import OrderCancellation from "./Component/OrderCancellation";
import InternationalOrders from "./Component/InternationalOrders";
import PaymentPolicy from "./Component/PaymentPolicy";
import ProductAccuracy from "./Component/ProductAccuracy";
import ProductCare from "./Component/ProductCare";
import ReviewsContent from "./Component/ReviewsContent";
import IntellectualProperty from "./Component/IntellectualProperty";
import Accessibility from "./Component/Accessibility";
import Packaging from "./Component/Packaging";
import Complaints from "./Component/Complaints";
import ContactPolicy from "./Component/ContactPolicy";
import Promotions from "./Component/Promotions";
import FinalSale from "./Component/FinalSale";
import PolicyUpdates from "./Component/PolicyUpdates";

function App() {
  return (
    <CartProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Header />
        <Routes>
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/terms-of-sale" element={<TermsOfSale />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/data-rights" element={<DataRights />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/policies" element={<PolicyIndex />} />
          <Route path="/parcel-issues" element={<ParcelIssues />} />
          <Route path="/cancellations" element={<OrderCancellation />} />
          <Route path="/international-orders" element={<InternationalOrders />} />
          <Route path="/payments" element={<PaymentPolicy />} />
          <Route path="/promotions" element={<Promotions />} />
          <Route path="/final-sale" element={<FinalSale />} />
          <Route path="/product-details-policy" element={<ProductAccuracy />} />
          <Route path="/product-care" element={<ProductCare />} />
          <Route path="/reviews-content" element={<ReviewsContent />} />
          <Route path="/intellectual-property" element={<IntellectualProperty />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="/packaging" element={<Packaging />} />
          <Route path="/complaints" element={<Complaints />} />
          <Route path="/policy-updates" element={<PolicyUpdates />} />
          <Route path="/contact-policy" element={<ContactPolicy />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/payment" element={<PaySuccess />} />
          <Route path="/paysuccess" element={<Navigate to="/payment?state=failed" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
